// extracted by mini-css-extract-plugin
module.exports = {"icon":"index_icon__WehXc","statistic_container":"index_statistic_container__UFrdK","row_item":"index_row_item__3Rs-2","logo":"index_logo__-1cMy","text":"index_text__29wGC"};